import React from 'react';
var Col = function (_a) {
    var children = _a.children, col = _a.col, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, offset = _a.offset, offsetSm = _a.offsetSm, offsetMd = _a.offsetMd, offsetLg = _a.offsetLg, offsetXl = _a.offsetXl, className = _a.className;
    var classCol = '';
    var ajoutClassCol = function (colonneClass) {
        if (classCol === '') {
            classCol = "fr-col-".concat(colonneClass);
        }
        else {
            classCol += " fr-col-".concat(colonneClass);
        }
    };
    if (!col && !sm && !md && !lg && !xl && !offset && !offsetSm && !offsetMd && !offsetLg && !offsetXl) {
        classCol = 'fr-col';
    }
    else {
        if (col)
            ajoutClassCol('' + col);
        if (sm)
            ajoutClassCol('sm-' + sm);
        if (md)
            ajoutClassCol('md-' + md);
        if (lg)
            ajoutClassCol('lg-' + lg);
        if (xl)
            ajoutClassCol('xl-' + xl);
        if (offset)
            ajoutClassCol('offset-' + offset);
        if (offsetSm)
            ajoutClassCol('offset-sm-' + offsetSm);
        if (offsetMd)
            ajoutClassCol('offset-md-' + offsetMd);
        if (offsetLg)
            ajoutClassCol('offset-lg-' + offsetLg);
        if (offsetXl)
            ajoutClassCol('offset-xl-' + offsetXl);
    }
    if (className) {
        classCol += " ".concat(className);
    }
    return (React.createElement("div", { className: classCol }, children));
};
export default Col;
